// ===============================|| Blank Layout ||=============================== //
<script setup lang="ts">
import { RouterView } from "vue-router";
import { ref } from "vue";

// 간단한 BlankLayout - stores 의존성 제거
const isRTL = ref(false); // 기본값은 LTR
</script>
<template>
  <!-----RTL LAYOUT------->
  <v-locale-provider v-if="isRTL" rtl>
    <v-app>
      <RouterView />
    </v-app>
  </v-locale-provider>

  <!-----LTR LAYOUT------->
  <v-locale-provider v-else>
    <v-app>
      <RouterView />
    </v-app>
  </v-locale-provider>
</template>
